{
"REGISTER-FUEL--FUELING-LABEL":"Reabastecimiento",  
"REGISTER-FUEL--REFUELING":"Ingrese los datos del reabastecimiento",  
"REGISTER-FUEL--VEHICLE":"Vehículo",
"REGISTER-FUEL--SELECT":"Seleccionar",
"REGISTER-FUEL--DRIVER":"Conductor",
"REGISTER-FUEL--LOCATION":"Lugar de reabastecimiento",
"REGISTER-FUEL--SUPPLIER":"Proveedor",
"REGISTER-FUEL--INVOICE":"Número de la factura",
"REGISTER-FUEL--AMOUNT":"Valor ($R)",
"REGISTER-FUEL--LITERS":"Litros Reabastecidos",
"REGISTER-FUEL--TYPE":"Tipo de Combustible",
"REGISTER-FUEL--ODOMETER":"Odómetro",
"REGISTER-FUEL--HOURMETER":"Horómetro",
"REGISTER-FUEL--NOTE":"Observación (opcional)  ",
"REGISTER-FUEL--ONLY-RECEIPT":"Comprobante",
"REGISTER-FUEL--RECEIPT":"Seleccione un comprobante",
"REGISTER-FUEL--PHOTO":"Tomar Foto del Comprobante",
"REGISTER-FUEL--SUBMIT":"Enviar",

  "REGISTER-FUEL--REGULAR-GASOLINE": "Gasolina Común",
  "REGISTER-FUEL--ADDITIVE-GASOLINE": "Gasolina Aditivada",
  "REGISTER-FUEL--PREMIUM-GASOLINE": "Gasolina Premium",
  "REGISTER-FUEL--REGULAR-DIESEL": "Diésel Común",
  "REGISTER-FUEL--DIESEL-S10": "Diésel S-10",
  "REGISTER-FUEL--ADDITIVE-DIESEL": "Diésel Aditivado",
  "REGISTER-FUEL--PREMIUM-DIESEL": "Diésel Premium",
  "REGISTER-FUEL--REGULAR-ETHANOL": "Etanol Común",
  "REGISTER-FUEL--ADDITIVE-ETHANOL": "Etanol Aditivado",
  "REGISTER-FUEL--ALCOHOL": "Alcohol",
  "REGISTER-FUEL--CNG": "GNC",
  "REGISTER-FUEL--ARLA": "ARLA",
  "REGISTER-FUEL--FETCHING-DATA": "Obteniendo datos ...",
  "REGISTER-FUEL--FETCH-DATA-FAILED": "¡No se pudieron obtener los datos!",
  "REGISTER-FUEL--FETCHING-ADDRESS": "Obteniendo dirección ...",
  "REGISTER-FUEL--LOCATION-INACCURATE": "La ubicación puede ser imprecisa...",
  "REGISTER-FUEL--INVALID-FIELDS": "¡Campos inválidos!",
  "REGISTER-FUEL--ODOMETER-OR-HOURMETER-REQUIRED": "¡Ingrese al menos el odómetro o el horómetro!",
  "REGISTER-FUEL--SAVING": "Guardando ...",
  "REGISTER-FUEL--TRY-AGAIN-LATER": "Inténtelo de nuevo más tarde...",
  "REGISTER-FUEL--FUEL-REGISTERED": "¡Abastecimiento registrado!"
}
